const ContactInfo = () => {
  const contactDetails = [
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      content: 'support@vorenntech.com',
      link: 'mailto:support@vorenntech.com',
    },
    {
      icon: 'ri-phone-line',
      title: 'Call Us',
      content: '+1 (314) 274 9959',
      link: 'tel:+15551234567',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Visit Us',
      content: '1178 Colfax Ave, Des Plaines, IL 60016',
      link: '#',
    },
  ];

  const businessHours = [
    { day: 'Monday - Friday', hours: '9:00 AM - 6:00 PM' },
    { day: 'Saturday', hours: '10:00 AM - 4:00 PM' },
    { day: 'Sunday', hours: 'Closed' },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-slate-900 mb-6">
          Contact Information
        </h2>
        <p className="text-base text-gray-600 mb-8">
          Reach out to us through any of these channels. Our team is ready to assist you with your IT needs.
        </p>

        <div className="space-y-6">
          {contactDetails.map((detail, index) => (
            <a
              key={index}
              href={detail.link}
              className="flex items-start space-x-4 p-4 bg-white rounded-xl border border-gray-200 hover:border-cyan-500 hover:shadow-lg transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg flex-shrink-0">
                <i className={`${detail.icon} text-white text-xl`}></i>
              </div>
              <div>
                <h3 className="text-base font-bold text-slate-900 mb-1">
                  {detail.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {detail.content}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>

      <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-8 text-white">
        <h3 className="text-2xl font-bold mb-6">Business Hours</h3>
        <div className="space-y-4">
          {businessHours.map((schedule, index) => (
            <div key={index} className="flex justify-between items-center pb-4 border-b border-slate-700 last:border-0">
              <span className="text-sm font-medium">{schedule.day}</span>
              <span className="text-sm text-cyan-300">{schedule.hours}</span>
            </div>
          ))}
        </div>
        <div className="mt-6 pt-6 border-t border-slate-700">
          <p className="text-sm text-gray-300">
            <i className="ri-time-line text-cyan-400 mr-2"></i>
            24/7 Emergency Support Available
          </p>
        </div>
      </div>

      <div className="bg-cyan-50 rounded-2xl p-8 border border-cyan-100">
        <h3 className="text-xl font-bold text-slate-900 mb-3">
          Need Immediate Assistance?
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          For urgent technical support, our team is available around the clock.
        </p>
        <button
          onClick={() => window.open('tel:+15551234567', '_self')}
          className="w-full px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-semibold rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-all whitespace-nowrap cursor-pointer"
        >
          Call Emergency Support
        </button>
      </div>
    </div>
  );
};

export default ContactInfo;